<div class="flex flex-col items-start">
    <h3 class="dashboard-title pl-2">
        {{ title() | transloco }}
        @if (fieldInterventionOperators()) {
            ({{ fieldInterventionOperators()!.entities!.length }})
        }
    </h3>
    <div
        class="bg-background w-full rounded-md entities-content py-4 mx-2"
        [ngClass]="fieldInterventionOperators() ? 'overflow-y-auto' : ''">
        @if (fieldInterventionEntities()) {
            @for (entity of getSortedEntitiesByStatus(); track entity) {
                <app-field-intervention-entity
                    [entity]="entity"
                    (click)="
                        openEntitiesFilteredTable(EntitiesDashboardInformationTypeEnum.BY_STATUS, entity.status)
                    " />
            }
        }

        @if (fieldInterventionOperators()) {
            @for (entity of fieldInterventionOperators()?.entities; track entity) {
                <app-field-intervention-operator
                    [operator]="entity"
                    (click)="openEntitiesFilteredTable(EntitiesDashboardInformationTypeEnum.BY_OPERATOR, entity.id)" />
            } @empty {
                <div class="flex flex-row justify-center m-auto p-8 rounded-md">
                    <fa-icon
                        class="text-red-700"
                        size="lg"
                        [icon]="['fad', 'triangle-exclamation']" />
                    <p class="empty-entity">{{ 'noOperatorAssigned' | transloco }}</p>
                </div>
            }
        }
    </div>
</div>
